import {Component, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {Location} from '@angular/common';
import {IQApiResultObject} from '../../interfaces/interfaces.regisafe';
import {SharedDataService} from '../../provider/shared-data/shared-data.service';
import {UserService} from '../../provider/user/user.service';
import {StorageService} from '../../provider/storage/storage.service';
import {ActivatedRoute, Router} from '@angular/router';
import {IQApiService} from '../../provider/iqapi/iqapi.service';
import {ErrorHandlingService} from '../../provider/error-handling/error-handling.service';
import {APP_ROUTES, APP_ICON_PATH} from '../../../environments/environment';
import {SessionDataService} from '../../provider/session-data/session-data.service';
import {IonInfiniteScroll} from '@ionic/angular';
import {SettingsService} from '../../provider/settings/settings.service';

@Component({
	selector: 'app-suchergebnisse',
	templateUrl: './suchergebnisse.page.html',
	styleUrls: ['./suchergebnisse.page.scss'],
})
export class SuchergebnissePage implements OnInit, OnChanges {

	@ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;

	result: IQApiResultObject;
	orgastruktur = '';
	firstSubStructuresInResults: Array<any> = [];
	body: any = {};
	appIconPath = APP_ICON_PATH;
	searchInOtherStructures = false;
	searchBody = null;
	firstHitCounter = 0;
	searchLevel1: number;
	resultCounter = '';
	cache = false;
	sortFields = '';

	constructor(private location: Location,
				private sharedService: SharedDataService,
				public userService: UserService,
				private storageService: StorageService,
				private sessionData: SessionDataService,
				private settingsService: SettingsService,
				private router: Router,
				private iqAPI: IQApiService,
				private errorHandling: ErrorHandlingService,
				private activatedRoute: ActivatedRoute) {
	}

	ngOnInit() {
		this.activatedRoute.data.subscribe((response: any) => {
			this.result = response.result.data;
			this.searchBody = response.result.body;
			this.cache = response.result.cache;
			this.searchInOtherStructures = response.result.searchInOtherStructures;
			this.resultCounter = this.result.objDatasets.length + '/' + this.result.totalCount;
			this.searchLevel1 = response.result.data.searchLevel1;
			this.sortFields = response.result.body.sortFields;
		});

		this.setRegisafeGlobalData();
	}

	ngOnChanges(changes: SimpleChanges) {
		console.log('ngOnChanges: ', changes);
	}

	ionViewDidLeave() {
		this.infiniteScroll.disabled = false;
	}

	ionViewDidEnter() {
		this.setRegisafeGlobalData();

		if (this.cache) {
			if (this.result.objDatasets.length === this.result.totalCount) {
				this.infiniteScroll.disabled = true;
			}
		}
	}

	async setRegisafeGlobalData() {
		this.orgastruktur = this.activatedRoute.snapshot.queryParamMap.get('osId');
		const headerTitle = await this.storageService.getOsStructNameFromConditions(this.orgastruktur);
		this.sharedService.setRegisafeGlobalData(
			{
				orgastruktur: this.orgastruktur,
				title: headerTitle
			});
	}

	async showDetail(data: any, firstSubStructure: string) {
		// eslint-disable-next-line no-underscore-dangle
		this.router.navigate([APP_ROUTES.detail, this.orgastruktur, this.userService.objIdAsRouteParam(data._ObjID)])
			.then((navigated) => {
				// do something or leave ist
			});
	}

	setFirstSubstructure(event) {
		this.firstSubStructuresInResults.push(event);
	}

	toggleInfiniteScroll() {
		this.infiniteScroll.disabled = !this.infiniteScroll.disabled;
	}

	async loadData(event) {

		this.firstHitCounter += this.settingsService.getUserSettings().getHits;
		this.searchBody.firstHit = this.firstHitCounter;

		const infiniteResult = await this.iqAPI.orgaManagerSearchObjectsEx(this.searchBody)
			.toPromise()
			.catch((e) => {
				console.log('orgaManagerSearchObjectsEx error lazy: ', e);
			});

		console.log('infiniteResult.objDatasets: ', infiniteResult);

		if (infiniteResult) {
			event.target.complete();
			this.result.objDatasets = this.result.objDatasets.concat(infiniteResult.objDatasets);
			this.result.totalCount = infiniteResult.totalCount;

			this.toggleInfiniteScroll();

			if (this.result.objDatasets.length < infiniteResult.totalCount) {
				event.target.disabled = false;
			} else {
				event.target.disabled = true;
				this.userService.presentDefaultToast('Keine weiteren Suchergebnisse gefunden.', 3000, 'bottom');
			}

			this.resultCounter = this.result.objDatasets.length + '/' + this.result.totalCount;
		}
	}

	async filterResults(event) {

		this.storageService.setSortingDataSelection(event.values, this.activatedRoute.snapshot.queryParamMap.get('osId'));

		this.infiniteScroll.disabled = false;
		this.result.objDatasets = [];
		this.searchBody.sortFields = event.values;

		this.firstHitCounter = 0;
		this.searchBody.firstHit = this.firstHitCounter;
		const result = await this.iqAPI.orgaManagerSearchObjectsEx(this.searchBody)
			.toPromise()
			.catch((e) => {
				console.log('orgaManagerSearchObjectsEx error lazy: ', e);
			});

		if (result) {
			this.result.objDatasets = result.objDatasets;
			this.resultCounter = this.result.objDatasets.length + '/' + this.result.totalCount;
		}
	}

	async loadSubData() {

		this.firstHitCounter = 0;
		this.searchBody.searchLevel1 = 0;

		this.infiniteScroll.disabled = false;

		const subResults = await this.iqAPI.orgaManagerSearchObjectsEx(this.searchBody)
			.toPromise()
			.catch((e) => {
				console.log('orgaManagerSearchObjectsEx error lazy: ', e);
			});

		this.result.objDatasets = subResults.objDatasets;
		this.resultCounter = subResults.objDatasets.length + '/' + subResults.totalCount;
		this.searchLevel1 = subResults.searchLevel1;

	}

}


